import { ExtractlyOfficeDialogMessageParentData } from '../types/dialog'

export const isDialogMessageParentEvent = (
  event: unknown
): event is ExtractlyOfficeDialogMessageParentData => {
  return (
    event !== null &&
    typeof event === 'object' &&
    '_tag' in event &&
    typeof event._tag === 'string' &&
    'data' in event &&
    typeof (event as any).data === 'string'
  )
}
